import classNames from "classnames";
const RailsWall = ({
  className,
  isActive,
}: {
  className?: string;
  isActive: boolean;
}) => (
  <svg
    height={70}
    viewBox="0 0 48 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(className, {
      "gg-fill-dark-blue": !isActive,
      "gg-fill-[#e5e5f1]": isActive,
    })}
  >
    <path
      d="M0 1a1 1 0 0 1 1-1h46a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1z"
      // fill="#292747"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 5a1 1 0 0 0-1 1v23a1 1 0 1 0 2 0 1 1 0 0 1 1-1h14a1 1 0 0 1 1 1 1 1 0 1 0 2 0V6a1 1 0 0 0-1-1H15z"
      fill="#69687E"
    />
    <path
      d="M25.5 68V45a1.5 1.5 0 0 0-3 0v23a1.5 1.5 0 0 0 3 0z"
      fill="#BFBEC8"
      stroke="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 29a1 1 0 0 0-1 1 1 1 0 0 1-1 1h-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V32a1 1 0 0 0-1-1h-1a1 1 0 0 1-1-1 1 1 0 0 0-1-1H18z"
      fill="#9493A3"
    />
  </svg>
);
export default RailsWall;
